import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from '../../services/axios';
import toast from 'react-hot-toast';
import { UserGroupIcon } from '@heroicons/react/24/outline';
import PageHeader from '../../components/common/PageHeader';
import EmptyState from '../../components/common/EmptyState';

const MentorInterns = () => {
    const [interns, setInterns] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            try {
                const response = await axios.get('/mentor/interns');
                setInterns(response.data.data || []);
            } catch (error) {
                toast.error(error.response?.data?.message || 'Failed to load assigned interns');
            } finally {
                setLoading(false);
            }
        };
        load();
    }, []);

    if (loading) {
        return (
            <div className="space-y-4" role="status" aria-live="polite">
                <div className="skeleton h-10 w-56" />
                <div className="skeleton h-24" />
                <div className="skeleton h-24" />
                <span className="sr-only">Loading assigned interns…</span>
            </div>
        );
    }

    return (
        <div className="w-full space-y-6">
            <PageHeader
                title="Assigned Interns"
                description="Interns assigned to you through cohorts, businesses, or projects."
            />

            {interns.length === 0 ? (
                <EmptyState
                    icon={UserGroupIcon}
                    title="No assigned interns yet"
                    description="Assigned interns will appear here once matching is complete."
                />
            ) : (
                <ul className="space-y-2">
                    {interns.map((intern) => {
                        const name = intern.user
                            ? `${intern.user.first_name} ${intern.user.last_name}`
                            : `Intern #${intern.id}`;
                        return (
                            <li key={intern.id} className="card-interactive animate-fade-up">
                                <div className="flex items-center justify-between gap-4">
                                    <div>
                                        <p className="font-semibold text-ink-950">{name}</p>
                                        <p className="text-sm text-ink-600">{intern.user?.email}</p>
                                    </div>
                                    <Link
                                        to={`/mentor/interns/${intern.id}`}
                                        className="btn-secondary !min-h-[40px]"
                                    >
                                        Open review
                                    </Link>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
};

export default MentorInterns;
